module.exports = __webpack_public_path__ + "img/jack-half.bb0df190.png";